import { ReferralDetail } from './referraldetail';

export class EmployeeReferralResponse {
    public errorCode!: string;
    public errorMessage!: string;
    public referralDetail: ReferralDetail = new ReferralDetail();
    public sessionValid: string =  '';
    public errorMessageData: string  = '';
    public verificationResult: string  = '';
    public appExpiry: string = '';
    public profileStrengthInfo: string = '';
    public successMessage: string = '';
    public success: boolean = false;
}

